import { v4 as createUUID } from 'uuid';
import coinflip from '@atlassian/ufo-coinflip';
import { getDoNotAbortActivePressInteraction, getInteractionRate } from '@atlassian/ufo-config';
import { DefaultInteractionID } from '@atlassian/ufo-interaction-id-context';
import { abortAll, addNewInteraction, getActiveInteraction } from '@atlassian/ufo-interaction-metrics';
import UFORouteName from '@atlassian/ufo-route-name-context';
export default function traceUFOPress(name, timestamp) {
  var rate = getInteractionRate(name, 'press');
  var pressInteractionsList = getDoNotAbortActivePressInteraction();
  if (pressInteractionsList !== null && pressInteractionsList !== void 0 && pressInteractionsList.includes(name)) {
    var interaction = getActiveInteraction();
    if ((interaction === null || interaction === void 0 ? void 0 : interaction.ufoName) !== 'unknown' && (interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') {
      return;
    }
  }
  if (coinflip(rate)) {
    abortAll('new_interaction', name);
    var startTimestamp = timestamp !== null && timestamp !== void 0 ? timestamp : performance.now();
    var newId = createUUID();
    DefaultInteractionID.current = newId;
    addNewInteraction(newId, name, 'press', startTimestamp, rate, [], UFORouteName.current);
  }
}